import { useContext, useMemo } from "react";
import type { Language } from "../model/language.ts";
import type { TextKey } from "./es.ts";
import { LanguageContext } from "./languageContext.ts";
import { translate } from "./translate.ts";

export { translate, TranslatableError, translateError } from "./translate.ts";
export type { Translate } from "./translate.ts";

/** The raw `language` value itself (not a translated text) — for language-sensitive formatting (dates, numbers) that useT() doesn't cover, e.g. `toLocaleString`. */
export function useLanguage(): Language {
  return useContext(LanguageContext);
}

/**
 * `t(key, params?)` — the value can carry `{name}`-style placeholders,
 * substituted with `params.name` (see es.ts/en.ts). Without a
 * `LanguageProvider` above it (e.g. a test mounting the component in
 * isolation) falls back to Spanish.
 */
export function useT() {
  const language = useContext(LanguageContext);
  return useMemo(
    () =>
      function t(key: TextKey, params?: Record<string, string | number>): string {
        return translate(language, key, params);
      },
    [language]
  );
}
